
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Vlan } from '@/api/interfaces';

@Component
export default class VlanTaggedSelectSelection extends Vue {
  @Prop() private item!: Vlan;
}
